import { Box, Stack } from "@mui/material";
import React, { FC, useState } from "react";
import SelectInput from "./UIElements/select";
import { medicType } from "./jobManagement/data";
import { LoadingButton } from "@mui/lab";
export const FilterApplicantInputs: FC<{
  loading: boolean;
  setFilterData: React.Dispatch<React.SetStateAction<string>>;
}> = ({ setFilterData, loading }) => {
  const [filters, setFilters] = useState({
    job_title: "",
    medic_type: "",
    status: "",
  });
  const handleFilterClicked = () => {
    setFilterData(`filter[status]=${filters.status}`);
  };
  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", my: 2, gap: 2, px: 2 }}>
      <Stack sx={{ width: 200 }}>
        <SelectInput
          label={"Medic type"}
          value={filters?.medic_type}
          onChange={(e) =>
            setFilters((prev) => ({
              ...prev,
              medic_type: e.target.value,
            }))
          }
          options={medicType}
        />
      </Stack>
      <Stack sx={{ width: 200 }}>
        <SelectInput
          label={"Status"}
          value={""}
          onChange={(e) =>
            setFilters((prev) => ({ ...prev, status: e.target.value }))
          }
          options={[
            { value: "draft", label: "Draft" },
            { value: "pending", label: "Pending" },
            { value: "closed", label: "Closed" },
          ]}
        />
      </Stack>
      <Stack
        sx={{ width: 150, mx: 3 }}
        direction={"row"}
        alignItems={"flex-end"}
      >
        <LoadingButton
          onClick={handleFilterClicked}
          loading={loading}
          variant="contained"
          sx={{ my: 3, width: 80 }}
        >
          Filter
        </LoadingButton>
      </Stack>
    </Box>
  );
};
